//本地静态路由
const staticRouter = [{
	path: '/',
	name: 'login',
	component: () => import('@/views/login')
},
{
	path: '/home',
	name: 'home',
	component: () => import('@/views/home')
},
{
	path: '/commandAndDispatch',
	name: 'commandAndDispatch',
	component: () => import('@/views/commandAndDispatchs/commandAndDispatch/index.vue')
},
{
	path: '/aEventEnter', // 事件接报录入
	name: 'aEventEnter',
	component: () => import('@/components/event/aEventEnter')
},
{
	path: '/bEventAnalysis', // 事件研判分析
	name: 'bEventAnalysis',
	component: () => import('@/components/event/bEventAnalysis')
},
{
	path: '/cEventResources', // 匹配相关资源
	name: 'cEventResources',
	component: () => import('@/components/event/cEventResources')
},
{
	path: '/dEventDispatch', // 资源调度
	name: 'dEventDispatch',
	component: () => import('@/components/event/dEventDispatch')
},
{
	path: '/eEventReport', // 事件处置完毕报告
	name: 'eEventReport',
	component: () => import('@/components/event/eEventReport')
},


{
	path: '/aRecord', // 记录
	name: 'aRecord',
	component: () => import('@/components/eventRecord/aRecord')
},
{
	path: '/bRecord', // 记录
	name: 'bRecord',
	component: () => import('@/components/eventRecord/bRecord')
},
{
	path: '/cRecord', // 记录
	name: 'cRecord',
	component: () => import('@/components/eventRecord/cRecord')
},
{
	path: '/dRecord', // 记录
	name: 'dRecord',
	component: () => import('@/components/eventRecord/dRecord')
},
{
	path: '/eRecord', // 记录
	name: 'eRecord',
	component: () => import('@/components/eventRecord/eRecord')
},
// {
//   path: '/home/population',
//   name: 'population',
//   component: () => import('@/views/home/population')
// },
// {
//   path: '/home/peopleStatistics',
//   name: 'peopleStatistics',
//   component: () => import('@/views/home/peopleStatistics')
// },
{
	path: '/Amanage', //事件处置页面
	name: 'Amanage',
	component: () => import('@/components/eventTransactComponents/Amanage')
},
{
	path: '/emergencyAmanage', //事件处置页面(应急管理)
	name: 'emergencyAmanage',
	component: () => import('@/views/eventCenter/meetEvent/components/Amanage.vue')
},
{
	path: '/eventSplice', //事件处置页面(应急管理)
	name: 'eventSplice',
	component: () => import('@/views/eventCenter/meetEvent/components/eventSplice.vue')
},
{
	path: '/eventSplices', //事件处置页面(应急管理)
	name: 'eventSplices',
	component: () => import('@/views/eventCenter/eventTransact/components/eventSplices.vue')
},
{
	path: '/Bupdata', //事件处置页面
	name: 'Bupdata',
	component: () => import('@/components/eventTransactComponents/Bupdata')
},
{
	path: '/CResourceAllocation', //资源分配页面
	name: 'CResourceAllocation',
	component: () => import('@/components/eventTransactComponents/CResourceAllocation')
},
{
	path: '/DisTisk', //资源分配页面
	name: 'DisTisk',
	component: () => import('@/components/eventTransactComponents/DisTisk')
},
{
	path: '/EupdataResoure', //资源分配页面
	name: 'EupdataResoure',
	component: () => import('@/components/eventTransactComponents/EupdataResoure')
},
{
	path: '/FJudged', //事件研判页面
	name: 'FJudged',
	component: () => import('@/components/eventTransactComponents/FJudged')
}, {
	path: '/GisTisk', //事件下派处置页面
	name: 'GisTisk',
	component: () => import('@/components/eventTransactComponents/GisTisk')
}
	, {
	path: '/HeventRecheck', //事件复核页面
	name: 'HeventRecheck',
	component: () => import('@/components/eventTransactComponents/HeventRecheck')
},
{
	path: '/401',
	name: 'error_401',
	meta: {
		show: false
	},
	component: () => import('@/components/common/errorPage/401.vue')
}, {
	path: '/500',
	name: 'error_500',
	meta: {
		show: false
	},
	component: () => import('@/components/common/errorPage/500.vue')
}, {
	path: '*',
	name: 'error_404',
	meta: {
		show: false
	},
	component: () => import('@/components/common/errorPage/404.vue')
},
]


export default staticRouter
